<!--
 * @Description: 访客计划 -- 编辑页面
 * @Author: mdb
 * @Date: 2022-07-19 11:12:06
 * @LastEditTime: 2022-09-14 11:07:55
 * @LastEditors: mdb
-->
<template>
  <CosLayoutMain>
    <template #content>
      <VisitorProgramForm
        ref="visitorProgramFormRef"
        title="访客计划"
        type="edit"
        v-model:value="dataForm"
        @update:value="fetch"
      />
    </template>
    <template #footer>
      <a-button @click="goBack()">取消</a-button>
      <a-button :loading="loading" @click="handleReset()">重置</a-button>
      <a-button v-permission="'fbu_visitor_edit_btn'" type="primary" :loading="loading" @click="handleSubmit()"
        >保存</a-button
      >
    </template>
  </CosLayoutMain>
</template>

<script setup lang="ts">
import { ref, reactive, toRaw, onBeforeMount } from 'vue'
import { useRoute } from 'vue-router'
import { cloneDeep } from 'lodash-es'
import { message } from '@dc-platform/dc-components'
import { goBack } from '@/hooks/cosRouter'
import VisitorProgramForm from '../components/VisitorProgramForm.vue'
import { visitorProgramCreateOrUpdate, visitorProgramDetail } from '@/api/gucangSales/followUpManage'
import type { FbuVisitorProgramEditParams } from '@/typings/api/followUpManage'
const route = useRoute()

const initForm: FbuVisitorProgramEditParams = reactive({})
const dataForm = reactive<FbuVisitorProgramEditParams>({})

onBeforeMount(() => {
  visitorProgramDetail(route.query.id as string).then((res) => {
    Object.assign(initForm, res.data)
    Object.assign(dataForm, res.data)
  })
})

const fetch = (val: any) => {
  Object.assign(dataForm, val)
}

const visitorProgramFormRef = ref()
const handleReset = () => {
  for (const key in dataForm) {
    dataForm[key] = undefined
  }
  Object.assign(dataForm, cloneDeep(initForm))
  setTimeout(() => {
    visitorProgramFormRef.value?.clearValidate()
  })
}
const loading = ref(false)
const handleSubmit = () => {
  visitorProgramFormRef.value?.validate().then(() => {
    loading.value = true
    const params = toRaw(dataForm)
    visitorProgramCreateOrUpdate(params)
      .then(() => {
        message.success('编辑成功')
        visitorProgramFormRef.value?.resetFields()
        goBack()
      })
      .finally(() => {
        loading.value = false
      })
  })
}
</script>
<script lang="ts">
export default { name: 'DcCosFbuVisitorProgramEdit' }
</script>

<style scoped></style>
